import React, { FC } from 'react';

import { Container, Svg } from '@lglp/components';

import styles from './DownloadIcon.module.scss';

const DownloadIcon: FC<DownloadIconProps> = ({ className, ...rest }) => {
  return (
    <Container className={[styles.downloadIcon, className]} {...rest}>
      <Svg viewBox="0 0 22 28" className={styles.downloadIcon_arrow}>
        <path
          d="M0 6h11.01l-4.165 4h2.944L15 5 9.789 0H6.845l4.165 4H0z"
          transform="rotate(90 6.955 6.955)"
        />
      </Svg>
      <Svg viewBox="0 0 22 28" className={styles.downloadIcon_line}>
        <path d="M0 0H17V2H0z" transform="translate(-.166 18.956)" />
      </Svg>
    </Container>
  );
};

type DownloadIconProps = {
  className?: string;
};

export default DownloadIcon;
